export enum GameInstanceEntryStateTypes
{
  Played = 6,
  Voided = 7,
  Refunded = 8,
  AutoplayedPaymentSuccessful = 1,
  AutoplayedPaymentProcessing = 2,
  AutoplayedPaymentFailure = 3,
  AutoplayedSystemError = 4,
  AutoplayedTicketLimitReached = 5,
  Redeemed = 9,
  PaymentFailure = 10,
  SystemError = 11,
  AutoplayedPaymentCharging = 16
}
